<!-- 假进度条组件 -->
<template>
  <div>
    <el-progress :percentage="percentage" :status="status" :show-text="false" />
    <div v-if="showhintText" class="hint-text">{{ hintText }}</div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ElProgress } from 'element-plus'
export type Status = '' | 'success' | 'exception' | 'warning'
const props = defineProps({
  valve: { type: Number, default: Math.random() * 10 + 80 },
  showhintText: { type: Boolean, default: false },
  step: { type: Number, default: 10 },
  interval: { type: Number, default: 200 }
})
let percentage = ref<number>(0)
let status = ref<Status>('')
let timer: any = null
let hintText = ref<string>('正在请求')

// 开始
function start(text?: string) {
  percentage.value = 0
  text && (hintText.value = text)
  status.value = ''
  timer = setInterval(() => {
    percentage.value <= props.valve && (percentage.value += Math.random() * props.step)
  }, props.interval)
}

// 结束
function finish(finishStatus: Status, text?: string) {
  switch (finishStatus) {
    case 'success':
      percentage.value = 100
      break
    case 'exception':
      timer && clearInterval(timer)
    case 'warning':
      break
    default:
      break
  }
  status.value = finishStatus
  text && (hintText.value = text)
}

function reset() {
  percentage.value = 0
  timer && clearInterval(timer)
  status.value = ''
}
defineExpose({
  start,
  finish,
  reset
})
</script>

<style scoped lang="scss">
.hint-text {
  margin-top: 8px;
  font-size: 12px;
  color: $color-text-hint;
  text-align: center;
}
</style>
